import React from 'react'
import { Outlet } from 'react-router'

function AuthLayout(): JSX.Element {
  return (
    <main className="layout auth-layout">
      <div className="container">
        <div className="auth-layout__inner">
          <Outlet></Outlet>
        </div>
      </div>
    </main>
  )
}

export default AuthLayout
